import React, { useContext, useEffect, useRef, useState } from "react";

// ------------------ COMPONENTES DE PRIMEREACT --------------------------
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Checkbox } from "primereact/checkbox";
import { TabView, TabPanel } from "primereact/tabview";
import { confirmDialog } from "primereact/confirmdialog";


// ------------------ COMPONENTES DE BASE --------------------------------
import { AuthContext } from "../../../../../Base/Context/AuthContext/AuthContext";
import Card from "../../../../../Base/Components/Card/Card";
import { toastShow } from "../../../../../Base/Services/ToastService";
import { getLabel } from "../../../../../Base/Services/Language/LanguageService";
import { baseLang } from "../../../../../Base/Lang/BaseLang";
import { ConfigContext } from "../../../../../Base/Context/ConfigContext/ConfigContext";
import { getDatesProduccion } from "../../../../../Base/Services/Moment/Luxon";
import { setTitlePage } from "../../../../../Base/Services/Config/ConfigService";
import CalendarioOperativo from "../../../../../Base/Components/Form/CalendarioOperativo";

// ------------------- CONSULTAS A LA API --------------------------------
import { ObtenerIngresosEncabezado } from "../../../../../API/Suministros/IngresosBodega/IngresosBodegaEncabezadoRequest";
import {
  cambiarRevisadoBodega,
  cambiarRecibidoCompras,
  ObtenerIngresosDetalle
} from "../../../../../API/Suministros/IngresosBodega/IngresosBodegaDetalleRequest";
import { getListadoDetalleOrdenes, getListadoOrdenes } from "../../../../../API/Compras/Ordenes/OrdenesComprasRequests";

// ------------------ COMPONENTES DE NECESARIOS --------------------------
import IngresosBodegaCrud from "./IngresosCRUD/IngresosBodegaCrud";
import OrdenesComprasCrud from "../../../Compras/OrdenesCompras/CrudOrdenesCompras/OrdenesComprasCrud";
import AgGrid from "../../../../../Base/Components/Tables/AgGrid/AgGrid";


const IngresoBodegaScreen = ({Bodega = false, MateriaPrima = false, Servicios = false}) => {
  const { userAuth } = useContext(AuthContext);
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);

  const [listadoEnc, setListadoEnc] = useState([]);
  const [listadoDet, setListadoDet] = useState([]);

  const [loading, setLoading] = useState(false);
  const [dates, setDates] = useState([]);
  const [showDialog, setShowDialog] = useState(false);
  const [ordenDialog, setOrdenDialog] = useState(false);
  const [ingresoToShow, setIngresoToShow] = useState(null);
  const [orderToShow, setOrderToShow] = useState(null);
  const [crudKey, setCrudKey] = useState(0);
  const [selectedDetalle, setSelectedDetalle] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [dataOrdenes, setDataOrdenes] = useState([]);
  const [dataDetalle, setDataDetalle] = useState([]);
  const [requisaEdit, setRequisaEdit] = useState(null);
  const [showDialogI, setShowDialogI] = useState(false);
  const [habilitar, setHabilitar] = useState(true);
  const [verCostosBodega, setVerCostosBodega] = useState(false);
  const [titulo, setTitulo] = useState(null);
  const [mostrarToastValidacion, setMostrarToastValidacion] = useState(false);
  const [hiddenPriceColumn, setHiddenPriceColumn] = useState(userAuth.AccessWeb.split(",").map((e) => parseInt(e)).includes(29));
  const [verCostos, setVerCostos] = useState(userAuth.AccessWeb.split(",").map((e) => parseInt(e)).includes(49) || userAuth.IdRol == 1);

  const getInfo = async () => {
    setLoading(true)
    setSelectedDetalle([]);
    if (!dates || dates.length !== 2 || !dates[0] || !dates[1]) {
      if (mostrarToastValidacion) {
        toastShow(
          toast,
          "warn",
          "Advertencia",
          "Por favor, seleccione un rango de fechas válido."
        );
      }

      setLoading(false);
      return;
    }
    setLoading(true);
    const fechas = getDatesProduccion(dates);

    const enc = await ObtenerIngresosEncabezado(fechas);
    const det = await ObtenerIngresosDetalle(fechas);

    let tipoIngreso = null;

    if (Bodega) {
      tipoIngreso = 1;
    } else if (MateriaPrima) {
      tipoIngreso = 2;
    } else if (Servicios) {
      tipoIngreso = 3;
    }

    const encabezadosFiltrados = enc.filter((i) => {
      if (Number(i.IdEstado) === 26) return false;
      if (MateriaPrima) return i.IsMateriaPrima === true;
      if (Bodega) return i.IsMateriaPrima !== true && Number(i.IdTipoIngreso) !== 3;
      if (Servicios) return Number(i.IdTipoIngreso) === 3;

      return true;
    });
    const detallesFiltrados = det.filter((i) => Number(i.IdTipoIngreso) === tipoIngreso && Number(i.IdEstado) !== 26);

    setListadoEnc(encabezadosFiltrados);
    setListadoDet(detallesFiltrados);
    setLoading(false)
  };

  const actualizarIngresosScreen = async () => {
    setLoading(true);
    const fechas = getDatesProduccion(dates);
    const det = await ObtenerIngresosDetalle(fechas);
    setListadoDet(det);
    setLoading(false);
  };

  const actualizarCompras = async () => {
    setLoading(true);
    const d = getDatesProduccion(dates);
    const t = await getListadoOrdenes(d);
    const dd = await getListadoDetalleOrdenes(d);
    setDataOrdenes(t);
    setDataDetalle(dd);
    setLoading(false);
  };

  const cerrarConfirmacion = () => {
    // Mostrar confirmación si hay ediciones sin guardar
    if (habilitar && ingresoToShow !== null) {
      confirmDialog({
        message: "¿Estás seguro de cerrar sin guardar los cambios?",
        header: "Cerrar sin guardar",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Sí",
        accept: () => {
          setShowDialog(null);
          setIngresoToShow(null); // Cerrar el diálogo
        },
        rejectLabel: "No",
        reject: () => {}, // No hacer nada si el usuario cancela
        style: { backgroundColor: "white" },
      });
    } else {
      setShowDialog(null);
      setIngresoToShow(null);
      setHabilitar(true);
    }
  };

  const cerrarModalOrdenes = () => {
    if (habilitar && orderToShow !== null) {
      confirmDialog({
        message: "¿Estás seguro de cerrar sin guardar los cambios?",
        header: "Cerrar sin guardar",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Sí",
        accept: () => {
          setOrdenDialog(null);
          setOrderToShow(null);
        },
        rejectLabel: "No",
        reject: () => {}, // No hacer nada si el usuario cancela
        style: { backgroundColor: "white" },
      });
    } else {
      setOrdenDialog(null);
      setOrderToShow(null);
      setHabilitar(true);
    }
  };

  const columns = [
    {// ID INGRESO DETALLE
      field: "IdIngresoDetalle",
      header: "ID",
      headerEn: "ID",
      className: "Xlarge",
      body: (rowData) => rowData.IdIngresoDetalle,
      frozen: "frozen",
      className: "XXsmall",
      hidden: userAuth.IdRol === 1,
    },
    {
      field: "FechaIngreso",
      header: "Fecha Ingreso",
      headerEn: "Fecha Ingreso",
      className: "Xlarge",
      frozen: "frozen",
      className: "small",
    },
    {
      header: "Estado",
      headerEn: "Status",
      field: "StatusName",
      className: "medium",
      frozen: true,
      Format: "Estado",
      body: (rowData) => ({ ID: rowData.IdEstado, Estado: rowData.StatusName }),
    },
    {
      field: "NumeroIngreso",
      headerEn: "Entry Number",
      header: "No. Ingreso",
      className: "small",
      body: (rowData) => rowData.NumeroIngreso,
      Format: "Modal",
      align: "center",
      Sumary: "count",
      frozen: "frozen",
      onCellDoubleClicked: ({ data }) => {
        Ingreso(data.NumeroIngreso);
      },
    },
    {
      field: "CodigoProducto",
      header: "Código",
      headerEn: "Code",
      // frozen: true,
      className: "Xsmall",
      body: (rowData) => rowData.CodigoProducto,
    },
    {
      field: "NombreProducto",
      header: "Nombre Producto",
      headerEn: "Product Name",
      className: "Xlarge",
    },
    {
      field: "NombreCategoria",
      header: "Tipo Producto",
      headerEn: "Product Type",
      className: "small",
    },
    {
      field: "NombreSubcategoria",
      header: "Categoría",
      headerEn: "Category",
      className: "small",
    },
    {
      field: "NombreTipoProducto",
      header: "Categoría",
      headerEn: "Category",
      className: "small",
    },
    {
      field: "CustomerName",
      header: "Proveedor",
      headerEn: "Supplier",
      className: "Xlarge",
    },
    {
      field: "Term",
      header: "Término de Compra",
      headerEn: "Purchase Term",
      className: "small",
    },
    {
      field: "Factura",
      header: "Factura",
      headerEn: "Invoice",
      className: "large",
    },
    {
      field: "NombreBodega",
      header: "Bodega",
      headerEn: "Warehouse Name",
      className: "large",
      body: (rowData) => rowData.NombreBodega,
    },
    {
      field: "NombreEstante",
      header: "Estante",
      headerEn: "Shelf Name",
      className: "Xsmall",
      body: (rowData) => rowData.NombreEstante,
    },
    {
      field: "NombrePosicion",
      header: "Fila",
      headerEn: "Position Name",
      className: "Xsmall",
      body: (rowData) => rowData.NombrePosicion,
    },
    {
      field: "NombreBandeja",
      header: "Bandeja",
      // headerEn: "Position Name",
      className: "Xsmall",
      body: (rowData) => rowData.NombreBandeja,
    },
    {
      field: "PurchaseOrder",
      header: "No. Orden",
      headerEn: "No. Order",
      className: "small",
      body: (rowData) => rowData.PurchaseOrder,
      Format: "Modal",
      align: "center",
      onCellDoubleClicked: ({ data }) => {
        OrdenC(data.PurchaseOrder);
      },
    },
    {
      field: "UnitName",
      header: "Unidad",
      headerEn: "Unit",
      className: "Xsmall",
      body: (rowData) => rowData.UnitName,
    },
    {
      field: "Currency",
      header: "Moneda",
      headerEn: "Currency",
      className: "Xsmall",
      body: (rowData) => rowData.Currency,
    },
    Servicios ? 
    {
      header: "Ingresado",
      headerEn: "Type",
      field: "CantidadReservada",
      Format: "Currency",
      className: "Xsmall",
      frozen: true,
      Sumary: "sum",
      alignFrozen: "right",
    } : 
    {
      header: "Ingresado",
      headerEn: "Type",
      field: "Ingreso",
      Format: "Currency",
      className: "Xsmall",
      frozen: true,
      Sumary: "sum",
      alignFrozen: "right",
    },
    {
      // Comment
      field: "NoLote",
      header: "No. Lote",
      headerEn: "No. Lote",
      className: "large",
      body: (rowData) => rowData.NoLote,
    },
    {
      // Comment
      field: "NoLoteInt",
      header: "No. Lote Interno",
      headerEn: "No. Lote Interno",
      hidden: userAuth.IdRol === 1,
      className: "large",
      body: (rowData) => rowData.NoLoteInt,
    },
    {
      // Comment
      field: "NoSacos",
      header: "No. Sacos",
      headerEn: "No. Sacos",
      Format: "Currency",
      // hidden: userAuth.IdRol === 1,
      className: "Xsmall",
      body: (rowData) => rowData.NoSacos,
    },
    {
      // Comment
      field: "FechaObsoleto",
      header: "Fecha Obsoleto",
      headerEn: "Fecha Obsoleto",
      className: "colum-width-Xlarge",
      body: (rowData) => rowData.FechaObsoleto,
      // frozen: "frozen",
      className: "small",
    },
    {
      // Comment
      field: "Inventario",
      header: "Inventario",
      headerEn: "Inventary",
      Format: "Currency",
      Sumary:"sum",
      className: "Xsmall",
      body: (rowData) => rowData.Inventario,
    },
    {
      header: "Requerido",
      headerEn: "Type",
      field: "Quantity",
      Format: "Currency",
      className: "Xsmall",
      Sumary:"sum",
    },
    {
      // Comment
      field: "TasaCambio",
      header: "Tasa Cambio",
      headerEn: "Exchange Rate",
      Format: "Decimal",
      // Sumary: "sum",
      className: "Xsmall",
      body: (rowData) => rowData.TasaCambio,
      hidden: userAuth.IdRol === 1,
      hidden: hiddenPriceColumn,
    },

    // EMBALAJE
    {
      headerName: 'Embalaje',
      children: [          
        {
          field: "EmbalajeL",
          header: "Monto L",
          Sumary: "sum",
          headerEn: "Monto L",
          hidden: verCostos || verCostosBodega,
          Format: "Currency",
          className: "small",
        },
        {
          field: "EmbalajeD",
          header: "Monto $",
          Sumary: "sum",
          headerEn: "Amount $",      
          hidden: verCostos || verCostosBodega,
          Format: "Currency",
          className: "small",
        },
      ]
    },

    // DESADUANAJE
    {
      headerName: 'Desaduanaje',
      children: [
        {
          field: "DesaduanajeL",
          header: "Monto L",
          Sumary: "sum",
          hidden: verCostos || verCostosBodega,
          headerEn: "Monto L",
          Format: "Currency",
          className: "small",
        },
        {
          field: "DesaduanajeD",
          header: "Monto $",
          Sumary: "sum",
          hidden: verCostos || verCostosBodega,
          headerEn: "Amount $",
          Format: "Currency",
          className: "small",
        },
      ]
    },
    // FLETE
    {
      headerName: 'Flete',
      children: [          
        {
          field: "FleteL",
          header: "Monto L",
          Sumary: "sum",
          hidden: verCostos || verCostosBodega,
          headerEn: "Monto L",
          Format: "Currency",
          className: "small",
        },
        {
          field: "FleteD",
          header: "Monto $",
          Sumary: "sum",
          hidden: verCostos || verCostosBodega,
          headerEn: "Amount $",
          Format: "Currency",
          className: "small",
        },
      ]
    },
    // OTROS COSTOS
    {
      headerName: 'Otros Costos',
      children: [          
        {
          field: "OtrosCostosL",
          header: "Monto L",
          Sumary: "sum",
          hidden: verCostos || verCostosBodega,
          headerEn: "Monto L",
          Format: "Currency",
          className: "small",
        },
        {
          field: "OtrosCostosD",
          header: "Monto $",
          Sumary: "sum",
          hidden: verCostos || verCostosBodega,
          headerEn: "Monto $",
          Format: "Currency",
          className: "small",
        },
      ]
    },

    // LEMPIRAS
    {
      headerName: 'Lempiras',
      header: 'Lempiras',
      children: [
        {
          // Comment
          field: "PrecioL",
          header: "Precio L",
          headerEn: "Price L",
          Format: "Currency",
          Sumary: "sum",
          className: "Xsmall",
          body: (rowData) => rowData.PrecioL,
          hidden: userAuth.IdRol === 1,
          hidden: hiddenPriceColumn,
        },
        {
          // Comment
          field: "SubTotal",
          header: "SubTotal L",
          headerEn: "SubTotal L",
          Format: "Currency",
          Sumary: "sum",
          className: "Xsmall",
          body: (rowData) => rowData.SubTotal,
          hidden: userAuth.IdRol === 1,
          hidden: hiddenPriceColumn,
        },
        {
          // Comment
          field: "ISVProductoL",
          header: "ISV L",
          headerEn: "IISV L",
          Format: "Currency",
          Sumary: "sum",
          className: "Xsmall",
          body: (rowData) => rowData.PrecioL,
          hidden: userAuth.IdRol === 1,
          hidden: hiddenPriceColumn,
        },
        {
          // Comment
          field: "Descuento",
          header: "Desc. L",
          headerEn: "Disc. L",
          Format: "Currency",
          Sumary: "sum",
          className: "Xsmall",
          body: (rowData) => rowData.Descuento,
          hidden: userAuth.IdRol === 1,
          hidden: hiddenPriceColumn,
        },
        {
          header: "MontoL",
          headerEn: "MontoL",
          // onChange: (data) => changePrecio(data),
          field: "MontoL",
          hidden: userAuth.IdRol === 1,
          hidden: hiddenPriceColumn,
          Format: "Currency",
          Sumary: "sum",
          className: "small",
        },
      ]
    },
    {// COSTO LEMPIRAS
      field: "CostoL",
      header: "Costo L",
      headerEn: "Costo L",
      Sumary: "sum",
      className: "Xsmall",
      Format: "Currency",
      body: (rowData) => rowData.MontoL,
      hidden: hiddenPriceColumn,
      frozen: true,
      alignFrozen: "right",
    },
    {// DOLARES
      headerName: 'Dolares',
      header: 'Dolares',
      children: [
        {
          // Comment
          field: "PrecioD",
          header: "Precio $",
          headerEn: "Price $",
          Sumary: "sum",
          Format: "Currency",
          className: "Xsmall",
          body: (rowData) => rowData.PrecioD,
          hidden: userAuth.IdRol === 1,
          hidden: hiddenPriceColumn,
        },
        {
          // Comment
          field: "SubTotalD",
          header: "SubTotal $",
          headerEn: "SubTotal $",
          Format: "Currency",
          Sumary: "sum",
          className: "Xsmall",
          body: (rowData) => rowData.SubTotalD,
          hidden: userAuth.IdRol === 1,
          hidden: hiddenPriceColumn,
        },
        {
          // Comment
          field: "ISVProductoD",
          header: "ISV $",
          headerEn: "ISV $",
          Format: "Currency",
          Sumary: "sum",
          className: "Xsmall",
          body: (rowData) => rowData.PrecioL,
          hidden: userAuth.IdRol === 1,
          hidden: hiddenPriceColumn,
        },
        {
          // Comment
          field: "DescuentoD",
          header: "Desc. %",
          headerEn: "Disc. $",
          Format: "Currency",
          Sumary: "sum",
          className: "Xsmall",
          body: (rowData) => rowData.DescuentoD,
          hidden: userAuth.IdRol === 1,
          hidden: hiddenPriceColumn,
        },
        {
          header: "Monto $",
          headerEn: "Amount $",
          // onChange: (data) => changePrecio(data),
          field: "MontoD",
          hidden: userAuth.IdRol === 1,
          hidden: hiddenPriceColumn,
          Format: "Currency",
          Sumary: "sum",
          className: "small",
        },
      ]
    },
    // COSTO D
    {
      // Comment
      field: "CostoD",
      Sumary: "sum",
      header: "Costo $",
      headerEn: "Cost $",
      className: "Xsmall",
      Format: "Currency",
      body: (rowData) => rowData.CostoD,
      hidden: hiddenPriceColumn,
      frozen: true,
      alignFrozen: "right",
    },

    {
      header: "PrecioUL",
      Sumary: "sum",
      headerEn: "PriceUL",
      field: "PrecioUL",
      hidden: userAuth.IdRol === 1,
      hidden: hiddenPriceColumn,
      Format: "Currency",
      className: "Xsmall",
    },

    {
      header: "PrecioUD",
      Sumary: "sum",
      headerEn: "PriceUD",
      field: "PrecioUD",
      hidden: userAuth.IdRol === 1,
      hidden: hiddenPriceColumn,
      Format: "Currency",
      className: "Xsmall",
    },

  ];

  const table = {
    Columns: columns,
    Data: listadoDet,
    loading: loading,
    selected: selectedDetalle,
    setSelected: (e) => setSelectedDetalle(e),
    showModal: (e) => showModal(e),
  };

  const showModal = (tipoModal) => {
    if (tipoModal === 'ingreso') {
      setShowDialog(true); 
    } else if (tipoModal === 'ordenCompra') {
      setOrdenDialog(true); 
    }
  };

  const Ingreso = (Id) => {
    setIngresoToShow(Id);
    setHabilitar(true);
    setCrudKey((prev) => prev + 1);
    setShowDialog(true);
  };
  
  const OrdenC = (Id) => {
    setOrderToShow(Id);
    setOrdenDialog(true)
    showModal('ordenCompra'); 
  };

  // BODEGA
  const changeRevisadoBodega = async (datos, e) => {
    if (!datos) {
      return;
    }
    if (![1, 38].includes(Number(userAuth?.IdRol))) {
      toastShow(
        toast,
        "warn",
        "Advertencia",
        "Permisos no autorizados."
      );
      return;
    }

    confirmDialog({
      message: e
        ? "¿Está seguro que desea marcar el ingreso como Revisado Bodega?"
        : "¿Está seguro que desea regresar el ingreso a Pendiente?",
      header: "Confirmación",
      icon: "pi pi-exclamation-triangle",

      accept: async () => {

        const ids = selectedDetalle.filter((item) => [78, 79].includes(Number(item?.IdEstadoRevisado))).map((item) => item.IdIngreso);
        const idsIngresos =ids.join(",") || datos?.IdIngreso;
        await cambiarRevisadoBodega(idsIngresos);

        toastShow(
          toast,
          "success",
          "Editado",
          e
            ? "Ingreso revisado por Bodega."
            : "Ingreso regresado a Pendiente."
        );

        getInfo();
      },

      reject: () => {},
    });

    setSelectedDetalle([]);
  };

  //COMPRAS
  const changeRecibidoCompras = async (datos, e) => {
    if (datos) {
      confirmDialog({
        message: `¿Está seguro que desea recibir ${selectedDetalle.length > 1 ? "los registros" : "el registro"}?`,
        header: "Confirmación",
        icon: "pi pi-exclamation-triangle",
        accept: async () => {
          let ids = selectedDetalle.filter((item) => [79, 80].includes(Number(item?.IdEstadoRevisado))).map((item) => item.IdIngreso);
          let idsDetalles = ids.join(",") || datos?.IdIngreso;
          
          //ROL COMPRAS , ADMIN
          if ([1, 25].includes(Number(userAuth?.IdRol))) {
             await cambiarRecibidoCompras(idsDetalles);

            toastShow(
              toast,
              "success",
              "Editado",
              "Registros revisados."
            );

            getInfo();
          } else {
            toastShow(
              toast,
              "warn",
              "Advertencia",
              "Permisos no autorizados."
            );
          }
        },
        reject: () => {},
      });
    
    }
    setSelectedDetalle([]);
  };

  const columns2 = [
    {// ID INGRESO ENCABEZADO
      field: "IdIngreso",
      header: "ID",
      headerEn: "ID",
      className: "colum-width-Xlarge",
      body: (rowData) => rowData.IdIngreso,
      frozen: "frozen",
      className: "XXsmall",
      hidden: userAuth.IdRol === 1,
    },
    {// FechaPermiso4
      field: "FechaIngreso",
      header: "Fecha de Ingreso",
      headerEn: "Date Create",
      className: "colum-width-medium",
      body: (rowData) => rowData.DateCreated,
      align: "center",
      Format: "DateTime2",
      frozen: "frozen",
    },
    {// ESTADO
      field: "StatusName",
      header: "Estado",
      headerEn: "Status",
      className: "small",
      body: (rowData) => ({
        ID: rowData.IdEstado,
        Estado: rowData.StatusName,
      }),
      frozen: "frozen",
      alignFrozen: "left",
      Format: "Estado",
    },
    {// No. Ingreso
      field: "NumeroIngreso",
      headerEn: "Entry Number",
      header: "No. Ingreso",
      className: "small",
      body: (rowData) => rowData.NumeroIngreso,
      Format: "Modal",
      align: "center",
      Sumary: "count",      
      frozen: "frozen",
      onCellDoubleClicked: ({ data }) => {
        Ingreso(data.NumeroIngreso);
      },
    },
    {// ESTADO REVISADO
      field: "EstadoRevisado",
      header: "Estado Revisión",
      headerEn: "Review Status",
      className: "small",
      body: (rowData) => ({
        ID: rowData.IdEstadoRevisado,
        Estado: rowData.EstadoRevisado,
      }),
      Format: "Estado",
      frozen: true,
      alignFrozen: "left",
    },
    {// CHECK REVISADO BODEGA
      field: "RevisadoBodega",
      header: "Revisado Bodega",
      headerEn: "Warehouse Reviewed",
      className: "small",
      Format: "Template",
      align: "center",
      frozen: "true",
      alignFrozen: "right",
      filter: false,
      hidden: [1, 38].includes(Number(userAuth?.IdRol)),
      body: (rowData) =>
        rowData?.IdIngreso ? (
          <div className="d-flex justify-content-center align-items-center">

            <Checkbox
              checked={[79, 80, 81, 82].includes(
                Number(rowData?.IdEstadoRevisado)
              )}

              disabled={
                Number(rowData?.IdEstadoRevisado) >= 80
              }

              onChange={(e) =>
                changeRevisadoBodega(
                  rowData,
                  e.checked
                )
              }
            />

          </div>
        ) : null,
    },
    {// CHECK RECIBIDO COMPRAS
      field: '',
      header: 'Recibido Compras',
      className: "small",
      Format: "Template",
      align: "center",
      frozen: "true",
      alignFrozen: "right",
      filter: false,
      hidden: [1, 25].includes(Number(userAuth?.IdRol)), //Roles Admin, Compras
      body: (rowData) =>  rowData?.IdIngreso && (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
        <Checkbox 
          onChange={(e) => {
            changeRecibidoCompras(rowData, e.checked)}
          }
          disabled={
            [78, 81, 82].includes(Number(rowData?.IdEstadoRevisado))
          }
          checked={
            [80, 81, 82].includes(Number(rowData?.IdEstadoRevisado))
          }
        />
      </div>
      ),
    },
    {// PurchaseOrder
      field: "PurchaseOrder",
      headerEn: "PO",
      header: "OC",
      className: "small",
      Format: "Modal",
      align: "center",
      onCellDoubleClicked: ({ data }) => {
        if (data?.PurchaseOrder) {
          OrdenC(data.PurchaseOrder);
        }
      },
    },
    {// COMENTARIOS
      field: "Comentarios",
      header: "Comentario",
      headerEn: "Comment",
      className: "]large",
    },
    {// FACTURAS
      field: "Factura",
      header: "Factura",
      headerEn: "Bill",
      className: "large",
    },
    {// FECHA FACTURA
      field: "FechaFactura",
      header: "Fecha Factura",
      headerEn: "Fecha Factura",
      className: "small",
    },
    {// PROVEEDOR
      field: "CustomerName",
      header: "Proveedor",
      headerEn: "Supplier",
      className: "large",
      body: (rowData) => rowData.IdVendor,
    },
    {// TERMINO DE COMPRA
      field: "Term",
      header: "Término de Compra",
      headerEn: "Payment Term",
      className: "Xsmall",
    },
    {// USUARIO INGRESO
      field: "UserNameIngreso",
      header: "Usuario Ingreso",
      headerEn: 'User Login',
      className: "small",
      body: (rowData) => rowData.UserNameIngreso,
    },
    {// USUARIO EDIT
      field: "UserNameEdit",
      header: "Usuario Edit",
      headerEn: "User Edit",
      className: "small",
      hidden: userAuth.IdRol === 1,
      body: (rowData) => rowData.UserNameEdit,
    },
    {// iSDOLLAR
      field: "IsDollar", 
      header: "IsDollar", 
      headerEn: "IsDollar", 
      className: "Xsmall",  
      align: 'center', 
      Format: "Template", 
      filter: false,
      body: (rowData) => {
        return (
          rowData.IdIngreso ? <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', paddingTop: '2px' }}>
            <Checkbox
              checked={rowData.IsDollar === true}
            />
          </div> : null
        );
      }
    },
    {// EMBALAJE
      headerName: 'Embalaje',
      hidden: userAuth?.IdRol === 1,
      children: [
        {
          field: "EmbalajeL",
          header: "Monto L",
          hidden: verCostos || verCostosBodega,
          headerEn: "Monto L",
          Format: "Currency",
          Sumary: "sum",
          className: "Xsmall",
        },
        {
          field: "EmbalajeD",
          header: "Monto $",
          hidden: verCostos || verCostosBodega,
          headerEn: "Amount $",
          Format: "Currency",
          Sumary: "sum",
          className: "Xsmall",
        },
        {
          field: "TasaCambioEmbalaje",
          header: "Tasa",
          hidden: verCostos || verCostosBodega,
          headerEn: "Tasa",
          Format: "Currency",
          className: "Xsmall",
        },
      ]
    },
    {// DESADUANAJE
      headerName: 'Desaduanaje',
      children: [
        {
          field: "DesaduanajeL",
          header: "Monto L",
          headerEn: "Monto L",
          Format: "Currency",
          Sumary: "sum",
          hidden: verCostos || verCostosBodega,
          className: "Xsmall",
        },
        {
          field: "DesaduanajeD",
          header: "Monto $",
          headerEn: "Amount $",
          Format: "Currency",
          hidden: verCostos || verCostosBodega,
          Sumary: "sum",
          className: "Xsmall",
        },
        {
          field: "TasaCambioDesaduanaje",
          header: "Tasa",
          headerEn: "Tasa",
          hidden: verCostos || verCostosBodega,
          Format: "Currency",
          className: "Xsmall",
        },
      ]
    },
    {// FLETE
      headerName: 'Flete',
      children: [
        {
          field: "FleteL",
          header: "Monto L",
          hidden: verCostos || verCostosBodega,
          headerEn: "Monto L",
          Format: "Currency",
          Sumary: "sum",
          className: "Xsmall",
        },
        {
          field: "FleteD",
          header: "Monto $",
          headerEn: "Amount $",
          hidden: verCostos || verCostosBodega,
          Format: "Currency",
          Sumary: "sum",
          className: "Xsmall",
        },
        {
          field: "TasaCambioFlete",
          hidden: verCostos || verCostosBodega,
          header: "Tasa",
          headerEn: "Tasa",
          Format: "Currency",
          className: "Xsmall",
        },
      ]
    },
    {// OTROS COSTOS
      headerName: 'OtrosCostos',
      children: [
        {
          field: "OtrosCostosL",
          header: "Monto L",
          headerEn: "Monto L",
          Format: "Currency",
          Sumary: "sum",
          hidden: verCostos || verCostosBodega,
          className: "Xsmall",
        },
        {
          field: "OtrosCostosD",
          header: "Monto $",
          headerEn: "Amount $",
          hidden: verCostos || verCostosBodega,
          Format: "Currency",
          Sumary: "sum",
          className: "Xsmall",
        },
        {
          field: "TasaCambioOtrosCostos",
          header: "Tasa",
          hidden: verCostos || verCostosBodega,
          headerEn: "Tasa",
          Format: "Currency",
          className: "Xsmall",
        },
      ]
    },
    {// LEMPIRAS
      headerName: 'Lempiras',
      header: 'Lempiras',
      children: [
        {
          // Comment
          field: "SubTotal",
          header: "SubTotal L",
          headerEn: "SubTotal L",
          Format: "Currency",
          Sumary: "sum",
          className: "Xsmall",
          hidden: userAuth.IdRol === 1,
          hidden: hiddenPriceColumn,
        },
        {
          // Comment
          field: "ISV",
          header: "ISV",
          Sumary: "sum",
          header: "ISV L",
          headerEn: "TAX L",
          Format: "Currency",
          className: "Xsmall",
          body: (rowData) => rowData.ISV,
          hidden: userAuth.IdRol === 1,
          hidden: hiddenPriceColumn,
        },
        {
          // Comment
          field: "Descuento",
          Sumary: "sum",
          header: "Desc. L",
          headerEn: "Disc. L",
          Format: "Currency",
          className: "Xsmall",
          hidden: userAuth.IdRol === 1,
          hidden: hiddenPriceColumn,
        },
      ]
    },
    {// DOLARES
      headerName: 'Dolares',
      header: 'Dolares',
      children: [
        {
          // Comment
          field: "SubTotalD",
          header: "SubTotal $",
          headerEn: "SubTotal $",
          Format: "Currency",
          Sumary: "sum",
          className: "Xsmall",
          hidden: userAuth.IdRol === 1,
          hidden: hiddenPriceColumn,
        },
        {
          // Comment
          field: "TAX",
          header: "ISV $",
          headerEn: "TAX $",
          Format: "Currency",
          Sumary: "sum",
          className: "Xsmall",
          body: (rowData) => rowData.TAX,
          hidden: userAuth.IdRol === 1,
          hidden: hiddenPriceColumn,
        },
        {
          // Comment
          field: "DescuentoD",
          header: "Desc. $",
          headerEn: "Disc. $",
          Format: "Currency",
          Sumary: "sum",
          className: "Xsmall",
          hidden: userAuth.IdRol === 1,
          hidden: hiddenPriceColumn,
        },
      ]
    },
    {// MONTO LEMPIRAS
      field: "MontoL",
      header: "Monto L",
      headerEn: "Monto L",
      Format: "Currency",
      className: "small",
      body: (rowData) => rowData.Total,
      Sumary: "sum",
      hidden: userAuth.IdRol === 1,
      frozen: true,
      alignFrozen: "right",
      hidden: hiddenPriceColumn,
    },
    {// MONTO DOLARES
      field: "MontoD",
      header: "Monto $",
      headerEn: "Monto $",
      Format: "Currency",
      className: "small",
      body: (rowData) => rowData.TotalD,
      Sumary: "sum",
      hidden: userAuth.IdRol === 1,
      frozen: true,
      alignFrozen: "right",
      hidden: hiddenPriceColumn,
    },
  ];

  const table2 = {
    Columns: columns2,
    Data: listadoEnc,
    fileName: "Ingresos Bodega" + new Date().toDateString(),
    loading: loading,
    clases: "tablaListados alturaListado60",
    showModal: (e) => showModal(e),
    key: "IdIngreso",
    selected: selectedDetalle,
    setSelected: (e) => setSelectedDetalle(e),
  };

  const nuevoIngreso = () => {
    setIngresoToShow(null);
    setOrderToShow(null);
    setHabilitar(true);
    setShowDialog(true);
  };
  
  useEffect(() => {
    getInfo();
    let Tittle2;

    if (Bodega) {
      Tittle2 = "Ingresos Bodega";
    } else if (Servicios) {
      Tittle2 = "Ingreso de Servicios";
    } else if (MateriaPrima) {
      Tittle2 = "Ingresos Materia Prima";
    }

    setTitulo(Tittle2);
    setTitlePage(
      getLabel(
        baseLang,
        Tittle2,
        config.language
      )
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    Bodega, MateriaPrima, Servicios, config.language
  ]);

  return (
    <div>
      <Toast ref={toast} />
      {/* <ConfirmDialog /> */}
      <Dialog
        header={
          <div className="botones flex-wrap  flex-wrap">
            {titulo}
          </div>
        }
        visible={showDialog}
        onHide={() => {
          cerrarConfirmacion();
        }}
        maximized={true}
        maximizable={true}
        closeOnEscape={false}
      >
        <IngresosBodegaCrud
          key={crudKey}
          idIngreso={ingresoToShow}
          setIngresoToShow={setIngresoToShow}
          showDialog={showDialog}
          actualizarIngresosScreen={actualizarIngresosScreen}
          actualizarIngresosScreenListado={getInfo}
          setOrderToShow={setOrderToShow}
          setOrdenDialog={setOrdenDialog}
          habilitar={habilitar}
          setHabilitar={setHabilitar}
          Bodega={Bodega}
          MateriaPrima={MateriaPrima}
          Servicios={Servicios}
        />
      </Dialog>

      <Dialog
        header="Orden de compras"
        visible={ordenDialog}
        onHide={() => {
          cerrarModalOrdenes();
        }}
        maximized={true}
        maximizable={true}
        closeOnEscape={false}
      >
        <OrdenesComprasCrud
          PurchaseOrder={orderToShow}
          setOrderToShow={setOrderToShow}
          ordenDialog={ordenDialog}
          setOrdenDialog={setOrdenDialog}
          actualizarCompras={actualizarCompras}
          setRequisaDialog={setShowDialogI}
          setRequisaToShow={setRequisaEdit}
          habilitar={habilitar}
          setHabilitar={setHabilitar}
        />
      </Dialog>

      <Card
        titulo={
          <div className="botones flex-wrap  flex-wrap">
            <h3>{getLabel(baseLang, titulo, config.language)}</h3>
            <CalendarioOperativo
              dates={dates}
              setDates={setDates}
              loading={loading}
              getInfo={getInfo}
            />
            <Button
              icon="pi pi-refresh"
              tooltip="Buscar"
              onClick={() => {
                setMostrarToastValidacion(true);
                getInfo();
              }}
            />
            <Button
              icon="pi pi-plus"
              tooltip="Nueva"
              onClick={nuevoIngreso}
            />


            {(userAuth?.IdRol === 38 || userAuth?.IdRol === 25)&& (
              <Button
                icon="pi pi-eye"
                type="button"
                onClick={() => setVerCostosBodega(!verCostosBodega)}
                tooltip={verCostosBodega ? 'Ocultar Costos' : 'Ver Costos'} 
                tooltipOptions={{
                  className: "purple-tooltip",
                  position: "top",
                }}
                style={{ marginLeft: 1.5 }}
              />
            )}
          </div>
        }
        contenido={
          <div className="pt-4">
            <TabView
              activeIndex={activeIndex}
              onTabChange={(e) => setActiveIndex(e.index)}
            >
              <TabPanel header="Listado">
                <div style={{ height: "82vh" }}>
                  <AgGrid table={table2} />
                </div>
              </TabPanel>

              <TabPanel header="Detalle">
                <div style={{ height: "82vh" }}>
                  <AgGrid table={table} />
                </div>
              </TabPanel>
            </TabView>
          </div>
        }
      />
    </div>
  );
};

export default IngresoBodegaScreen;
